import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "components/Attachments/UploadAttachment.css";
import { FirebaseServices } from "../../api/FirebaeServices";
import { Services } from "../../api/Services";
import ProgressBar from "@ramonak/react-progress-bar";

const VideoUploadPopup = ({
  videoFile,
  workoutId,
  onClose,
  onVideoUploaded
}) => {
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [isCanceled, setIsCanceled] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const xhrRef = useRef(null);
  const [errorMsg, setErrorMessage] = useState("");

  // Memoize video preview URL to prevent flickering
  const videoPreviewUrl = React.useMemo(() => {
    if (videoFile) {
      return URL.createObjectURL(videoFile);
    }
    return null;
  }, [videoFile]);

  // Cleanup object URL when videoFile changes or component unmounts
  useEffect(() => {
    return () => {
      if (videoPreviewUrl) {
        URL.revokeObjectURL(videoPreviewUrl);
      }
    };
  }, [videoPreviewUrl]);

  useEffect(() => {
    if (!videoFile) return;
    if (videoUrl === "") {
        setIsUploading(true);
        setIsCanceled(false);
        handleUploadFile();
    }
  }, [videoFile]);

  const handleCancel = () => {
    setIsCanceled(true);
    setIsUploading(false);
    if (xhrRef.current) {
        console.log("Cancelling upload...");
        xhrRef.current.cancel();
    }
    toast.info("Upload canceled");
    if (onClose) onClose();
  };

 const handleUploadFile = async () => {
     
    setErrorMessage("");
    const fileSizeInMB = videoFile.size / (1024 * 1024);
    if (fileSizeInMB > 500) {
      setErrorMessage("File size exceeds 500 MB limit.");
      setIsUploading(false);
      return;
    }

    const fileType = videoFile.type.split("/").pop().split(".").pop();
    if (!fileType) {
      setErrorMessage("Invalid File Type");
      setIsUploading(false);
      return;
    }

    try {
      // Update: get both uploadTask and fileLink from fileUpload
      const { uploadTask, urlPromise } = await FirebaseServices.fileUploadWithCancel(
        videoFile,
        setProgress
      );
      xhrRef.current = uploadTask;
      const fileLink = await urlPromise;
      if (fileLink) {
        setVideoUrl(fileLink);
        setIsCanceled(false);
        if (onVideoUploaded) onVideoUploaded(fileLink);
      } else {
        setErrorMessage("Failed To Upload File");
      }
    } catch (error) {
      setErrorMessage("Failed To Upload File");
    } finally {
      setIsUploading(false);
    }
};

  return (
    <div className="video-upload-popup" style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", padding: 24, borderRadius: 8, minWidth: 320, maxWidth: "90vw", maxHeight: "90vh", overflowY: "auto", boxSizing: "border-box", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <h3 style={{ marginTop: 0 }}>Uploading Video</h3>
        <p style={{ textAlign: "center" }}>Please don't close window while upload is in progress</p>
        {videoFile && videoPreviewUrl && (
          <video 
            src={videoPreviewUrl} 
            controls 
            style={{ 
              marginBottom: 16, 
              maxWidth: "100%", 
              maxHeight: "50vh", 
              borderRadius: 4, 
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)" 
            }} 
          />
        )}
        {errorMsg && (
          <div style={{ color: 'red', marginBottom: 12 }}>{errorMsg}</div>
        )}
        {(isUploading || progress > 0) && (
          <div className="px-2 mb-2 mt-1" style={{ width: "100%" }}>
            <div className="uploaded-progress">
              <ProgressBar
                completed={Math.round(progress)}
                height="10px"
                isLabelVisible={false}
                bgColor="#4e10ff"
              />
            </div>
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
          <button onClick={handleCancel} disabled={!isUploading} style={{ marginRight: 8 }}>Cancel</button>
          <button onClick={onClose} disabled={isUploading}>Close</button>
        </div>
        <span style={{ marginTop: 8 }}> Progress: {Number(progress).toFixed(3)}%</span>
      </div>
    </div>
  );
};

export default VideoUploadPopup;
